import { CircularProgress, circularProgressClasses } from "@mui/material";
import { CMBox, CMProgress, CMGrayProgress } from "./loading-child.styles";

const LoadingChild = ({size}) => {
    return (
        <CMBox>
            <CMProgress color='primary' thickness={5} size={ size ? size: 50 } value={100} variant='indeterminate' disableShrink />
            {/* <CMProgress color='primary' thickness={5} size={50} value={100} variant='indeterminate' disableShrink /> */}
            
        </CMBox>
    )
}

export default LoadingChild;